<template>
  <div class="tranche-picker ui-select">
    <input
      placeholder="Tranche"
      :value="selectedText"
      @click="togglePicker()"
    >
    <span
      class="ui-icon ui-icon-triangle-1-s"
    />
    <div
      v-if="expanded"
      class="tranche-picker__content"
    >
      <ul>
        <li
          v-for="tranche of tranchesOptions"
          :key="`tranche_${tranche.id}`"
          @click="setTranche(tranche)"
        >
          {{ tranche.libelle }}
        </li>
      </ul>
      <button @click="openTrancheForm()">
        Ajouter Tranche
      </button>
    </div>
  </div>
</template>
<script>
import TrancheForm from '../../modal/content/TrancheForfaitTransportForm'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      expanded: false,
      selected: null
    }
  },
  computed: {
    ...mapGetters(['tranchesOptions', 'trancheSelected']),
    selectedText() {
      if (this.tranchesOptions === null || this.trancheSelected === null) return null
      return this.tranchesOptions.find(trancheOption => {
        return trancheOption.id === this.trancheSelected.id
      }).libelle
    }
  },
  methods: {
    togglePicker() {
      this.expanded = !this.expanded
    },
    setTranche(tranche) {
      let id = null
      if (tranche !== null ) {
        id= tranche.id
      }

      this.selected = id
      this.$store.dispatch('setTranche', tranche)
      this.$emit('selected', id)
    },
    openTrancheForm() {
      this.$store.dispatch('openTrancheForm')
    }
  }
}
</script>
<style scoped>
.tranche-picker {
  position: relative;
  display: flex;
  flex-direction: column;
  border: 0 none;
}

.tranche-picker input {
  width: 169px;
}
.tranche-picker .ui-icon,
.tranche-picker .ui-icon:hover {
  position: absolute;
  top: 5px;
  right: 2px;
  min-width: 16px;
  background-color: #ffffff;
  border: 5px solid #ffffff;
  outline: 0 none;
}

.tranche-picker__content {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 29px;
  width: 179px;
  border: 1px solid #a9a9a9;
  background-color: #ffffff;
  max-height: 400px;
  overflow: auto;
}
.tranche-picker__content ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.tranche-picker__content li {
    padding: 3px 10px;
  }
.tranche-picker__content li:hover {
    background-color: #eeeeee;
  }
</style>
